export default [
  'company-zone',
  'company-industry',
  'company-trade',
  'work-nature',
  'work-progress',
  'project-progress',
  'media-cloud-file-attribute-value',
  'media-cloud-file-attribute',
  'news-type',
  // 'work-log-edit-time-setting',
  'company-introduction',
  'user-role',
  'user-group',
  'user-account',
  'supervisor-evaluation',
  'repair-area',
  'repair-status',
  'repair-form-type',
  'repair-warranty-type',
  'repair-product-from',
  'repair-service-type',
  'repair-owner-judgement',
  'repair-currency',
  'repair-service-satisfaction',
  'repair-issue-type',
  // 'repair-service-edit-time-setting'
  'system-parameter-setting'
];


// WEBPACK FOOTER //
// ./src/salesky/routes/newAdmin/adminRouteList.js